<script setup lang="ts">
import {useResponsiveElement} from '@/ts/composables/pure/use-responsive-element';
import {computed} from 'vue';
import type {ComponentContent} from '@/ts/types/dto/interventions-dto';
import RouterLinkWithOrigin from '@/vue/atoms/router-link-with-origin.vue';

const props = withDefaults(defineProps<{
  blockContent: ComponentContent;
  currentPageTitle: string;
  /**
   * Ids to read before the title, as suffixes of the card's own id. Only the slotted card knows
   * what it rendered, and naming an id that is not on the page would leave a dead reference on
   * every other card that shares this base.
   */
  labelSuffixes?: string[];
}>(), {labelSuffixes: () => []});

const {elementRef, width} = useResponsiveElement();
const idAria = computed(() => `block_content_${props.blockContent.id}`);
const labelledBy = computed(() =>
  [...props.labelSuffixes.map((suffix) => `${idAria.value}-${suffix}`), idAria.value].join(' '));
const blockContentLink = computed(() => ({
  name: 'block-content',
  params: {
    itemId: props.blockContent.id,
  },
}));
</script>
<template>
  <router-link-with-origin
    v-if="blockContentLink"
    :to="blockContentLink"
    :origin-page-title="currentPageTitle"
    class="rec-link"
    :aria-labelledby="labelledBy"
  >
    <div ref="elementRef">
      <slot :width="width" :id-aria="idAria"/>
    </div>
  </router-link-with-origin>
</template>
